/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Shortcut_Keys_Save_Project_Error_ToastInputs */



/**
* | output |
* | --- |
* | "Save project completed with error. {error}" |
*
* @param {Shortcut_Keys_Save_Project_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_save_project_error_toast = /** @type {((inputs: Shortcut_Keys_Save_Project_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Save_Project_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Enregistrement du projet termine avec erreur. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Projekt mit Fehler gespeichert. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Salvataggio del progetto completato con errore. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Сохранение проекта завершилось с ошибкой. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Guardar proyecto completado con error. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`项目保存失败。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プロジェクトの保存がエラーで完了しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रोजेक्ट सेव करने में त्रुटि आई। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Projeto salvo concluído com erro. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Save project completed with error. ${i?.error}`)
});